import Alicce from "../assets/images/testimony/alicce.png";
import Du from "../assets/images/testimony/du.png";
import Jucelia from "../assets/images/testimony/jucelia.png";
import Whilineia from "../assets/images/testimony/whilineia.png";

export const testimonies: string[] = [Alicce, Du, Jucelia, Whilineia];
